import { CmsApiGradCtaHeroBlockData } from 'modules/cms/api/types/blocks/CmsApiGradCtaHeroBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpGradCtaHeroBlock } from './CmsAmpGradCtaHeroBlock';
import { CmsGradCtaHeroBlock } from './CmsGradCtaHeroBlock';

export const CmsGradCtaHeroBlockMapping: CmsBlockMapping<CmsApiGradCtaHeroBlockData> =
  {
    invariant: [
      {
        prop: 'text',
        msg: 'Text data required for call to action',
      },
      {
        prop: 'image',
        msg: 'Image data required for call to action',
      },
    ],
    width: CmsMappedBlockWidth.FULL,
    Component: CmsGradCtaHeroBlock,
    AmpComponent: CmsAmpGradCtaHeroBlock,
  };
